import { render, staticRenderFns } from "./EditEditor.vue?vue&type=template&id=57f482af&"
import script from "./EditEditor.vue?vue&type=script&lang=ts&"
export * from "./EditEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EditEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports